import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Plus: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.49922 0.923391V15.0566" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M15.5723 7.99195L1.42578 7.99048" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg {...props} fill="none" stroke="currentColor" width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};